import axios from "axios";
import { personas } from "../../components/generico/utils/UrlAPI";
import authService from "../login/auth.service";

export async function obtenerDatosOficialCuenta() {
    var config = {
        method: "get",
        url: personas + "oficial-cuenta/",
        headers: {
            "Content-Type": "application/json",
            "Authorization": "Bearer " + authService.getCurrentToken()
        }
    };

    return await axios(config);
}